export default "__VITE_PUBLIC_ASSET__77d43214__"